import { AiOutlineInfo } from "react-icons/ai";
import Button from "../../../../../atoms/Button";
import CardHeader from "../../../../../atoms/CardHeader";
import Breadcrumb from "../../../../../molecules/Breadcrumb";
import useModal from "../../../../../../hooks/useModal";
import Modal from "../../../../../molecules/Modal";
import InfoEmpresa from "../../../../../templates/clientes/InfoEmpresa";

const DFMenuHeader = ({ empresa, caso }) => {
    const { open: openInfo, close, isOpen } = useModal();

    return(
        <CardHeader>
            <Breadcrumb
                items={[
                    { label: `${empresa?.name || "cargando..."}`, to: `/clientes/empresas/${empresa?.id}/decide` },
                    { label: "DEFENSA FISCAL", to: `/clientes/empresas/${empresa?.id}/defensa_fiscal` },
                    { label: caso?.origin && caso?.authority ? `${caso.origin} - ${caso.authority}` : "...cargando",
                        to: `/clientes/empresas/${empresa?.id}/decide`
                    }
                    ]}
            />
            <Button
                text={<AiOutlineInfo size={22} />}
                bgColor="black"
                width="w-10"
                onClick={openInfo}
            />
            {isOpen && empresa &&
                <Modal title="Información" onClose={close}>
                    <InfoEmpresa empresa={empresa} />
                </Modal>
            }
        </CardHeader>
    );
}

export default DFMenuHeader;